import { request } from "@/service/request.js";

/**
 * 订单详情
 * @param {*} options
 * @returns
 */
export function getSingle(options) {
  return request.call(this, {
      url: "openapi/web/product/single",
      method: 'POST',
      data:options
  });
}

/**
 * 获取票信息
 * @param {*} options
 * @returns
 */
export function getProductMulti(options) {
  return request.call(this, {
      url: "openapi/web/product/multi",
      method: 'POST',
      data:options
  });
}
